export default __webpack_public_path__ + "ea98759bfbd9b2e0886cc815e5da6df8.png";